module.exports = __webpack_public_path__ + "img/support-icon.ab663337.svg";